const config = {
    baseUrl: 'https://cms.ok2land.escolhadigital.com/api/',
    imagesUrl: 'http://cms.ok2land.escolhadigital.com',
    loginEndpoint: 'auth/local',
    changePasswordEndpoint: 'auth/change-password',
    hubspot_api_key: 'pat-eu1-604c4bf7-7482-4608-b86c-98cc0cb09fbb',
    hubspot_url: 'https://api.hubapi.com/contacts/v1/contact/'
};
  
export default config;